export const REGISTRATION_PUBLIC_NAME_SS_KEY = 'registration-public-name';
